package utils

import io.ktor.utils.io.core.toByteArray
import korlibs.crypto.MD5

val String.md5: String
    get() = MD5.create().let { h ->
        h.update(toByteArray())
        h.digest().base64Url
    }

val Iterable<Any?>.md5: String get() = MD5.create().let { h ->
    this.filterNotNull().forEach { obj ->
        if(obj is ByteArray) {
            h.update(obj)
        } else {
            obj.toString().toByteArray().let { bytes ->
                h.update(bytes)
            }
        }
    }
    h.digest().base64Url
}
val Array<out Any?>.md5: String get() = MD5.create().let { h ->
    this.filterNotNull().forEach { obj ->
        if(obj is ByteArray) {
            h.update(obj)
        } else {
            obj.toString().toByteArray().let { bytes ->
                h.update(bytes)
            }
        }
    }
    h.digest().base64Url
}

object HashUtils {
    fun md5(vararg objs: Any?)  = objs.md5
}
